<div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">
  <div class="row d-flex flex-row">
    <div class="col-sm-12 align-items-center">
    
      <div class="auth-box">
        
         <div class="logo-above-auth-box logo-tenant-as-background"></div>

          <form [formGroup]="orderForm">

            <h1>{{ 'checkout.details' | translate }}</h1>
            <p class="title-subtext">
              {{ 'checkout.enterdetails' | translate }}
            </p>

            <div class="row">
              <div class="col-md-12">

                <h3 class="with-line">{{ 'checkout.delivery-address' | translate }} </h3>

                <div class="delivery-address">
                  <app-addresses [addresses]="addresses"
                                [current]="deliveryAddressNumber"
                                (addressChanged)="setAddress('delivery', $event)">
                  </app-addresses>
                  <span class="text-danger form-error" *ngIf="orderForm.touched && !deliveryAddress">
                  {{ 'validation.required' | translate: {field: 'checkout.delivery-address' | translate} }}
                </span>
              </div>

              <h3 class="with-line">{{ 'checkout.delivery-date' | translate }} </h3>
              <app-date-picker formControlName="dlvDate" tabindex="1"></app-date-picker>
              <span class="text-danger form-error" *ngIf="orderForm.touched && !orderForm.get('dlvDate').valid">
              	{{ 'checkout.delivery-date-validate' | translate }}
            </span>
            </div>
            <div class="col-md-12">

              <!-- reference -->
              <h3 class="with-line">{{ 'checkout.reference-title' | translate }} </h3>
              <input placeholder="" id="order-reference" class="form-control reference" formControlName="customerReference" tabindex="2" />

              <!-- remarks -->
              <h3 class="with-line">{{ 'checkout.remarks' | translate }} </h3>
              <textarea class="form-control remarks" formControlName="comments" placeholder="" tabindex="3"></textarea>
              <!-- <i class="fa fa-pencil" aria-hidden="true"></i> -->


              <h3 class="with-line" *ngIf="checkoutPageSettings?.showOrderType">Order type </h3>

              <div class="ordertype" *ngIf="checkoutPageSettings?.showOrderType">
                <div class="form-group">
                  <input id="order" type="radio" value="Order" formControlName="type" name="type">
                  <label for="order">Order</label>
                </div>
                <div class="form-group">
                  <input id="offerte" type="radio" value="Offerte" formControlName="type" name="type">
                  <label for="offerte">Offerte</label>
                </div>
                <span class="text-danger form-error" *ngIf="orderForm.get('type').touched && !orderForm.get('type').valid">
                {{ 'validation.required' | translate: {field: 'type'} }}
              </span>
              </div>

            </div>
            <div class="col-12">
              <app-form-error [error]="errors"></app-form-error>
            </div>
          </div>

          <!-- back and place order -->
          <div class="row row-back-and-place-order" *ngIf="hasLines">
            <div class="col-md-6 back">
              <a routerLink="/checkout" class="btn btn-back"><i class="fa fa-arrow-left"></i>{{ 'details.back-button' | translate }}</a>
            </div>
            <div class="col-md-6 text-right place-order">
              <button type="submit" [disabled]="committing" class="btn btn-success btn-icon-right btn-order" [ngClass]="{ 'btn-run-progress' : committing }" (click)="submit()" tabindex="3">
                {{ 'checkout.submit-order' | translate }} <i class="fa fa-arrow-right"></i>
              </button>
            </div>
          </div>

          <div class="row" *ngIf="!hasLines">
            <div class="col-md-12">
              <hr />
              <div class="alert alert-warning" role="alert">
                {{ 'checkout.cart-empty' | translate }}
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>
